"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItemQuantityCell = void 0;
const cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
const react_1 = __importDefault(require("react"));
const react_number_format_1 = require("react-number-format");
const useDebouncedState_1 = require("../../../utils/useDebouncedState");
const ItemQuantityCell = (props) => {
    const [debouncedItem, setDebouncedItem] = (0, useDebouncedState_1.useDebouncedState)(props.item, props.onItemChange, 300, { leading: true });
    function handleChange(value) {
        let validValue = value ? Math.max(0, value) : 0;
        validValue = Math.min(validValue, 100000);
        validValue = Math.round(validValue * 100) / 100;
        const itemClone = (0, cloneDeep_1.default)(debouncedItem);
        itemClone.quantity = validValue;
        setDebouncedItem(itemClone);
    }
    let quantityElement;
    if (props.isResource) {
        quantityElement = (react_1.default.createElement("div", { className: "flex-grow-1 text-right" },
            react_1.default.createElement(react_number_format_1.NumericFormat, { className: "quantity-label-readonly", displayType: "text", thousandSeparator: "'", decimalSeparator: ".", decimalScale: 2, fixedDecimalScale: false, value: debouncedItem.quantity })));
    }
    else {
        quantityElement = (react_1.default.createElement("div", { className: "flex-grow-1" },
            react_1.default.createElement(react_number_format_1.NumericFormat, { className: "w-100 text-right", displayType: "input", thousandSeparator: "'", decimalSeparator: ".", decimalScale: 2, fixedDecimalScale: false, onFocus: (e) => e.target.select(), value: debouncedItem.quantity, onValueChange: (e) => { var _a; return handleChange((_a = e.floatValue) !== null && _a !== void 0 ? _a : 0); }, disabled: !props.editable })));
    }
    return react_1.default.createElement("div", { className: "d-flex" }, quantityElement);
};
exports.ItemQuantityCell = ItemQuantityCell;
